import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

// 		{% set list = [ 1,2,3,4 ] %}

export class SetArrayBlock extends AbstractBlock {
  VAR_NAME = 'VAR_NAME';

  VALUE = 'VALUE';

  constructor() {
    super('logic_set_array_v2', 'array-set');
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementShape(block);

    // フィールド
    const var_name = new Blockly.FieldTextInput('list');
    const value = new Blockly.FieldTextInput(' 1, 2, 3, 4 ');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('配列', 'set_array1'))
      .appendField(var_name, this.VAR_NAME)
      .appendField(t.to('にカンマ区切りの複数の値', 'set_array2'))
      .appendField(value, this.VALUE)
      .appendField(t.to('をセット', 'set_array3'));
  }

  codeGenerateCore(block: BlockType): string {
    const varName = CodeSetting.getFieldValue(block, this.VAR_NAME);
    const value = CodeSetting.getFieldValue(block, this.VALUE); //getTrimCode(block,self.VALUE);
    let str = null;
    const valueString = value
      .split(',')
      .map((data) => {
        // 文字列かつ、"や'で括られていないなら括る ( {}ならオブジェクトとして扱う )
        const item = data.trim();
        if (
          !parseInt(item) &&
          !item.startsWith(`{`) &&
          !item.endsWith(`}`) &&
          !(item.startsWith(`"`) || item.startsWith(`'`)) &&
          !(item.endsWith(`"`) || item.endsWith(`'`))
        ) {
          return `"${item}"`;
        }
        //
        return item;
      })
      .join(',');

    str = `let ${varName} = [ ${valueString} ];`;

    return str;
  }
}
